/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/no-array-index-key */

import React, { PureComponent } from 'react';

import { Map, Item, Icon, Labels, Title, SecondaryTitle } from './styles';

export default class TrustBadgesListMobile extends PureComponent {
    render() {
        const { list } = this.props;

        return (
            <div>
                {list.length !== 0 && (
                    <Map>
                        {list.map((item, i) => (
                            <Item href={item.url} target="_blank" key={i}>
                                <Icon src={item.icon} alt="icon" />
                                <Labels>
                                    <Title>{item.title}</Title>
                                    <SecondaryTitle>{item.secondaryTitle}</SecondaryTitle>
                                </Labels>
                            </Item>
                        ))}
                    </Map>
                )}
            </div>
        );
    }
}
